export default __webpack_public_path__ + "static/card-02-38611eab35458f4e53624b019a19d949.jpg";